import * as THREE from "three";
import React, { useRef, useEffect } from "react";
import { useFrame, useLoader } from "@react-three/fiber";
import { GLTFLoader } from "three/examples/jsm/loaders/GLTFLoader";

const GltfLoaderAni = ({ MeshPath, col, speed =1, offset=0 }) => {
  const group = useRef();
  const mixer = useRef();

  // Load GLTF model
  const gltf = useLoader(GLTFLoader, MeshPath);

  useEffect(() => {
    // Set up mixer for animation
    mixer.current = new THREE.AnimationMixer(gltf.scene);

    // Start playing animations
    const actions = {};
    gltf.animations.forEach((clip) => {
      actions[clip.name] = mixer.current.clipAction(clip);
      actions[clip.name].play();
    });

    mixer.current.setTime(offset);
  }, [gltf, offset]);

  useEffect(() => {
    gltf.scene.traverse((child) => {
      if (child.isMesh) {
        child.castShadow = false;
        child.receiveShadow = false;

        child.material.color.set(col);
      }
    });
  }, [gltf, col]);

  // Update animation every frame
  useFrame((_, delta) => {
    if (mixer.current) {
      mixer.current.update(delta * speed); //change speed
    }
  });

  return <primitive object={gltf.scene} ref={group} />;
};

export default GltfLoaderAni;